import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
):
  | {
      date: string;
      prescriptions: number;
    }[]
  | null => {
  //   console.log(res.data);
  const newData = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const { date, prescriptions } = res.data.data[i];
      newData.push({
        date,
        prescriptions,
      });
    }

    return newData;
  }

  return null;
};

export const useGetPrescriptionsTrend = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.prescriptionsTrendWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get("analytics/prescriptions/daily-trends", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            staff_id: userId,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Prescriptions trend]", res);
      handleErrors(res, "query");
    },
  });
};
